// extracted by mini-css-extract-plugin
module.exports = {"container":"Dg-z","creativeContainer":"Eg-z","copy":"Fg-z","cta":"Gg-z","disabled":"Hg-z","flipped":"Ig-z","card":"Jg-z"};